import { Component, ElementRef, Inject, OnInit, ViewChild } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-progress-mautic',
  templateUrl: './progress-mautic.component.html',
  styleUrls: ['./progress-mautic.component.scss']
})
export class ProgressMauticComponent implements OnInit {

  formData: any = {};
  @ViewChild('form', { static: false }) form: ElementRef<any>;

  constructor(
    router: ActivatedRoute,
    @Inject('FORM_API_URL') public formApiUrl: string
  ) {

    router.queryParams.subscribe(
      query => {
        // console.log('CHEGOU =>',query);
        this.formData = {
          email: query.email,
          passo: query.passo
        }
        // console.log(this.formData);
        setTimeout(() => this.form.nativeElement.submit(), 500);
      }
    )

  }

  ngOnInit(): void {

  }

}
